import { NotificationCountModel } from "@/model/notification/NotificationCountModel";
import { NotificationModel } from "@/model/notification/NotificationModel";

const NotificationDB = "NotificationDB";
const ObjectStoreNotificationUnreadCount = "notificationUnreadCount";
const ObjectStoreNotificationUnread = "notificationUnread";
const ObjectStoreNotificationRead = "notificationRead";
const indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;

export const OpenNotificationIndexedDB = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    if (!indexedDB) throw new Error("Your browser doesn't support IndexedBD");

    const request = indexedDB.open(NotificationDB, 1);

    request.onerror = (e) => {
      console.error(`IndexedDB error: ${request.error}`);
    };

    request.onsuccess = (e: any) => {
      const db = e.target.result;
      resolve(db);
    };

    request.onupgradeneeded = (e: any) => {
      const db = e.target.result;
      db.createObjectStore(ObjectStoreNotificationUnreadCount, { keyPath: "merchantId" });
      db.createObjectStore(ObjectStoreNotificationUnread, { keyPath: "merchantId" });
      db.createObjectStore(ObjectStoreNotificationRead, { keyPath: "merchantId" });
    };
  });
};

export const AddUnreadNotificationToIndexedDB = async (notificationModel: NotificationModel): Promise<void> => {
  const db = await OpenNotificationIndexedDB();
  return new Promise((resolve, reject) => {
    if (db) {
      const request = db
        .transaction([ObjectStoreNotificationUnread], "readwrite")
        .objectStore(ObjectStoreNotificationUnread)
        .add(notificationModel);

      request.onsuccess = (event: any) => {
        db.close();
        resolve();
      };
      request.onerror = (err: any) => {
        console.error(`Error to add new Tap: ${err}`);
        db.close();
        resolve();
      };
    } else {
      resolve();
    }
  });
};

export const UpdateUnreadNotificationToIndexedDB = async (notificationModel: NotificationModel): Promise<void> => {
  const db = await OpenNotificationIndexedDB();
  return new Promise((resolve, reject) => {
    if (db) {
      const request = db
        .transaction([ObjectStoreNotificationUnread], "readwrite")
        .objectStore(ObjectStoreNotificationUnread)
        .put({ ...notificationModel });

      request.onsuccess = (event: any) => {
        db.close();
        resolve();
      };
      request.onerror = (err: any) => {
        console.error(`Error to add new Tap: ${err}`);
        db.close();
        resolve();
      };
    } else {
      resolve();
    }
  });
};

export const GetUnreadNotificationFromIndexedDB = async (merchantId: number): Promise<NotificationModel | null> => {
  const db = await OpenNotificationIndexedDB();
  return new Promise((resolve, reject) => {
    if (db) {
      const request = db
        .transaction([ObjectStoreNotificationUnread], "readwrite")
        .objectStore(ObjectStoreNotificationUnread)
        .get(merchantId);

      request.onsuccess = () => {
        const taps = request.result;
        db.close();
        resolve(taps);
      };

      request.onerror = (err: any) => {
        console.error(`Error to get all taps: ${err}`);
        db.close();
        resolve(null);
      };
    } else {
      resolve(null);
    }
  });
};

export const AddReadNotificationToIndexedDB = async (notificationModel: NotificationModel): Promise<void> => {
  const db = await OpenNotificationIndexedDB();
  return new Promise((resolve, reject) => {
    if (db) {
      const request = db
        .transaction([ObjectStoreNotificationRead], "readwrite")
        .objectStore(ObjectStoreNotificationRead)
        .add(notificationModel);

      request.onsuccess = (event: any) => {
        db.close();
        resolve();
      };
      request.onerror = (err: any) => {
        console.error(`Error to add new Tap: ${err}`);
        db.close();
        resolve();
      };
    } else {
      resolve();
    }
  });
};

export const UpdateReadNotificationToIndexedDB = async (notificationModel: NotificationModel): Promise<void> => {
  const db = await OpenNotificationIndexedDB();
  return new Promise((resolve, reject) => {
    if (db) {
      const request = db
        .transaction([ObjectStoreNotificationRead], "readwrite")
        .objectStore(ObjectStoreNotificationRead)
        .put({ ...notificationModel });

      request.onsuccess = (event: any) => {
        db.close();
        resolve();
      };
      request.onerror = (err: any) => {
        console.error(`Error to add new Tap: ${err}`);
        db.close();
        resolve();
      };
    } else {
      resolve();
    }
  });
};

export const GetReadNotificationFromIndexedDB = async (merchantId: number): Promise<NotificationModel | null> => {
  const db = await OpenNotificationIndexedDB();
  return new Promise((resolve, reject) => {
    if (db) {
      const request = db
        .transaction([ObjectStoreNotificationRead], "readwrite")
        .objectStore(ObjectStoreNotificationRead)
        .get(merchantId);

      request.onsuccess = () => {
        const taps = request.result;
        db.close();
        resolve(taps);
      };

      request.onerror = (err: any) => {
        console.error(`Error to get all taps: ${err}`);
        db.close();
        resolve(null);
      };
    } else {
      resolve(null);
    }
  });
};

export const AddNotificationCountToIndexedDB = async (
  notificationCountModel: NotificationCountModel
): Promise<void> => {
  const db = await OpenNotificationIndexedDB();
  return new Promise((resolve, reject) => {
    if (db) {
      const request = db
        .transaction([ObjectStoreNotificationUnreadCount], "readwrite")
        .objectStore(ObjectStoreNotificationUnreadCount)
        .add(notificationCountModel);

      request.onsuccess = (event: any) => {
        db.close();
        resolve();
      };
      request.onerror = (err: any) => {
        console.error(`Error to add new Tap: ${err}`);
        db.close();
        resolve();
      };
    } else {
      resolve();
    }
  });
};

export const UpdateNotificationCountToIndexedDB = async (
  notificationCountModel: NotificationCountModel
): Promise<void> => {
  const db = await OpenNotificationIndexedDB();
  return new Promise((resolve, reject) => {
    if (db) {
      const request = db
        .transaction([ObjectStoreNotificationUnreadCount], "readwrite")
        .objectStore(ObjectStoreNotificationUnreadCount)
        .put({ ...notificationCountModel });

      request.onsuccess = (event: any) => {
        db.close();
        resolve();
      };
      request.onerror = (err: any) => {
        console.error(`Error to add new Tap: ${err}`);
        db.close();
        resolve();
      };
    } else {
      resolve();
    }
  });
};

export const GetNotificationCountFromIndexedDB = async (merchantId: number): Promise<NotificationCountModel | null> => {
  const db = await OpenNotificationIndexedDB();
  return new Promise((resolve, reject) => {
    if (db) {
      const request = db
        .transaction([ObjectStoreNotificationUnreadCount], "readwrite")
        .objectStore(ObjectStoreNotificationUnreadCount)
        .get(merchantId);

      request.onsuccess = () => {
        const taps = request.result;
        db.close();
        resolve(taps);
      };

      request.onerror = (err: any) => {
        console.error(`Error to get all taps: ${err}`);
        db.close();
        resolve(null);
      };
    } else {
      resolve(null);
    }
  });
};

export const ClearNotificationByObjectStoreName = async (ObjectStoreName: string): Promise<void> => {
  const db = await OpenNotificationIndexedDB();
  return new Promise((resolve, reject) => {
    if (db) {
      const request = db
        .transaction([ObjectStoreName], "readwrite")
        .objectStore(ObjectStoreName)
        .clear();

      request.onerror = (event: any) => {
        db.close();
        resolve();
      };

      request.onsuccess = (event: any) => {
        db.close();
        resolve();
      };
    } else {
      resolve();
    }
  });
};

export const ClearNotificationIndexedDB = async (): Promise<void> => {
  await ClearNotificationByObjectStoreName(ObjectStoreNotificationUnreadCount);
  await ClearNotificationByObjectStoreName(ObjectStoreNotificationUnread);
  await ClearNotificationByObjectStoreName(ObjectStoreNotificationRead);
  return new Promise((resolve, reject) => {
    resolve();
  });
};
